import { z } from 'zod'

export const UnreadCountsEnum = z.enum([
  'chats',
  'ticketChats',
  'otherNotifications'
])
export type UnreadCountsEnum = z.infer<typeof UnreadCountsEnum>
